import React from 'react';
import { theme } from '@fiverr-private/theme';
import { L1_ICON_SIZES } from '../../constants';
import type { L1IconType } from '../../types';

const PdfL1Icon = ({ size = 'sm', color = 'currentColor' }: L1IconType) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={L1_ICON_SIZES[size]}
    height={L1_ICON_SIZES[size]}
    fill={theme.colors[color]}
    viewBox="0 0 21 25"
  >
    <path
      fillRule="evenodd"
      d="M2.168 2.842c.32-.32.753-.499 1.205-.499h7.84v4.159a1.977 1.977 0 0 0 1.978 1.977h4.159v4.123a.75.75 0 0 0 1.5 0V7.729c0-.2-.079-.383-.207-.517l-.013-.013-6.136-6.136-.008-.008a.75.75 0 0 0-.522-.212h-8.59A3.204 3.204 0 0 0 .168 4.047v8.555a.75.75 0 0 0 1.5 0V4.047c0-.452.18-.885.5-1.205m10.546.562v3.098a.477.477 0 0 0 .477.477h3.098zM.169 16.222a.75.75 0 0 1 .75-.75h1.84a2.59 2.59 0 1 1 0 5.181H1.67v2.932a.75.75 0 0 1-1.5 0zm1.5 2.931h1.09a1.09 1.09 0 1 0 0-2.181H1.67z"
      clipRule="evenodd"
    />
    <path d="M19.327 16.972h-2.932v2.181H18.1a.75.75 0 0 1 0 1.5h-1.705v2.932a.75.75 0 0 1-1.5 0v-7.363a.75.75 0 0 1 .75-.75h3.682a.75.75 0 1 1 0 1.5" />
    <path
      fillRule="evenodd"
      d="M8.282 15.472a.75.75 0 0 0-.75.75v7.363c0 .414.336.75.75.75H9.51a3.205 3.205 0 0 0 3.205-3.204v-2.455a3.204 3.204 0 0 0-3.205-3.204zm.75 7.363v-5.863h.477a1.704 1.704 0 0 1 1.705 1.704v2.455a1.704 1.704 0 0 1-1.705 1.704z"
      clipRule="evenodd"
    />
  </svg>
);
PdfL1Icon.displayName = 'PdfL1Icon';
export default PdfL1Icon;
